export function createFormattedAuthHeader(header: string) {
  const formattedAuthHeaders = {
    headers: {
      Authorization: header,
    },
  };

  return formattedAuthHeaders;
}
